import { render, staticRenderFns } from "./DemoCarDetail.vue?vue&type=template&id=eb2a1464"
import script from "./DemoCarDetail.vue?vue&type=script&lang=js"
export * from "./DemoCarDetail.vue?vue&type=script&lang=js"
import style0 from "./DemoCarDetail.vue?vue&type=style&index=0&id=eb2a1464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports